// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DateCalendarIcon from "@hardwoods/XDL/Icons/DateCalendarIcon";
import { xBaseTheme } from "@hardwoods/XDL/types";

import { color } from "@hardwoods/XDL/Utilities";
import DatePickerPresentationPropsDefault from "@insite/mobius/DatePicker/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DatePickerPresentationPropsDefault,
        calendarIconProps: { src: DateCalendarIcon, color: "secondary" },
        cssOverrides: {
            ...DatePickerPresentationPropsDefault?.cssOverrides,
            datePicker: css`
                ${DatePickerPresentationPropsDefault?.cssOverrides?.datePicker}

                &&& .react-datetime-picker {
                    height: 40px;
                    padding: 0 10px;
                    border-radius: 2px;
                    box-shadow: inset 0 1px 0 0 ${color("common.black", 0.1)};
                    border: 1px solid ${color("common.ui13")};

                    color: ${({ disabled, theme }: any) =>
                        disabled ? theme.colors.common.ui1 : theme.colors.text.secondary};
                    &__inputGroup__divider {
                        padding: 0 5px;
                    }
                    &__inputGroup__leadingZero {
                        color: ${color("text.main")};
                    }
                    &__clear-button ${IconWrapper} {
                        background: transparent;
                    }
                }
                .react-calendar {
                    width: 272px; // to fix small mobile screen size issue
                    box-shadow: 0 0 8px 0 ${color("text.secondary", 0.5)};

                    &__navigation__label {
                        font-size: 14px;
                    }

                    &__month-view {
                        &__weekdays {
                            font-size: 12px;
                            font-weight: bold;
                            letter-spacing: 0.41px;
                            line-height: 12px;
                            color: ${color("text.main")};
                        }
                        &__days {
                            &__day {
                                font-size: 14px;
                                letter-spacing: 0;
                                line-height: 26px;
                                border-radius: 5px;
                                &[disabled],
                                &--neighboringMonth {
                                    color: ${color("common.ui14")};
                                    cursor: not-allowed;
                                    opacity: 0.5;
                                }
                            }
                        }
                    }

                    button {
                        &:not(.react-calendar__navigation__label) {
                            color: ${color("text.secondary")};
                        }
                        &:enabled {
                            &:hover:not(:disabled),
                            &:focus:not(:disabled) {
                                background-color: ${color("#E0E0E0")};
                                &:after {
                                    display: none;
                                }
                            }
                        }
                        &[class*="--now"] {
                            color: ${color("text.secondary")};
                            font-weight: 400;
                            background-color: ${color("#E0E0E0")};
                        }
                    }

                    &__tile {
                        &--hasActive:not(:disabled):not(.react-calendar__month-view__days__day--neighboringMonth),
                        &--active:not(:disabled):not(.react-calendar__month-view__days__day--neighboringMonth) {
                            color: ${color("primary")};
                            background: transparent;
                            font-weight: 200;
                            position: relative;
                            &:after {
                                content: "";
                                background: ${color("primary")};
                                width: calc(100% - 5px);
                                height: 1px;
                                position: absolute;
                                bottom: 6px;
                                left: 50%;
                                transform: translateX(-50%);
                            }
                        }
                        &--now {
                            &:after {
                                display: none;
                            }
                        }
                    }
                }
            `,
        },
    },
} as xBaseTheme["datePicker"];
